module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pInXJV/media/FC-9781398450745.jpg?1708992389060",
      "alt": "This image is the cover for the book Won't Stop Moving"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Won't Stop Moving\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sometimes the answer isn’t to be the rock in the river, letting the water wash over you. Sometimes the answer is to be the leaf, floating down the stream and rolling with the constant change that is life. Won’t Stop Moving is designed to help you remember the lessons that you have forgotten to remember. This book gives you the opportunity to remind yourself of what you already know, deep in your soul. You can’t stop moving, and you won’t stop moving, growing and evolving. This is an oracle book. It works like oracle cards, but rather than shuffling, turn to the page number you’re called to, and receive a message that you are ready to learn or remember. Or read the book sequentially. Or front to back, back to front, inside out or outside in. Read it upside down if you want, but I wouldn’t recommend it. You choose. You will be called to the lessons you need. Trust the process. Trust your instincts.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sam Creedon-Gray\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Commonly known as the physical manifestation of ADHD, Sam Creedon-Gray has had six careers, three surnames, two new hobbies a year, and one child. When she’s not riding motorcycles, making recycled candles or cooking, Sam indulges in her 22+ year special interest in spirituality, the occult, religion, psychology and science—believing they are all intertwined.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0